/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "./../lib/httpClient.ts";
import {
  CreateMenuDefinitionRequestDTO,
  Response,
  UpdateMenuDefinitionRequestDTO,
} from "././index.d.ts";

export class Menus<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Get menu definition by menu id.
   *
   * @tags uimanager
   * @name GetMenuDefinition
   * @request GET:/menus/{menuId}
   * @secure
   */
  getMenuDefinition = (menuId: string, params: RequestParams = {}) =>
    this.http.request<Response, Response>({
      path: `/menus/${menuId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an existing menu definition.
   *
   * @tags uimanager
   * @name UpdateMenuDefinition
   * @request PUT:/menus/{menuId}
   * @secure
   */
  updateMenuDefinition = (
    menuId: string,
    data: UpdateMenuDefinitionRequestDTO,
    params: RequestParams = {},
  ) =>
    this.http.request<Response, Response>({
      path: `/menus/${menuId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Return all menu definitions ordered by last update time descending.
   *
   * @tags uimanager
   * @name ListMenuDefinition
   * @request GET:/menus
   * @secure
   */
  listMenuDefinition = (params: RequestParams = {}) =>
    this.http.request<Response, Response>({
      path: `/menus`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new menu definition.
   *
   * @tags uimanager
   * @name CreateMenuDefinition
   * @request POST:/menus
   * @secure
   */
  createMenuDefinition = (
    data: CreateMenuDefinitionRequestDTO,
    params: RequestParams = {},
  ) =>
    this.http.request<Response, Response>({
      path: `/menus`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
